import { FunctionComponent } from 'react';

import { IconEllipses } from '@tock/icons';
import { Typography } from 'omakase';
import AchievementCircle from 'components/profile/achievements/AchievementCircle';

export interface Props {
  nOverflowElements: number;
  onClick(): void;
}

const OverflowButton: FunctionComponent<Props> = ({ nOverflowElements, onClick }) => {
  return (
    <button className="Achievement_button" onClick={onClick} aria-label="View all achievements">
      <AchievementCircle className="Achievement-overflow">
        {nOverflowElements > 0 ? (
          <Typography color="inherit" component="span" variant="body02">
            <b>{`+${nOverflowElements}`}</b>
          </Typography>
        ) : (
          <IconEllipses fontSize="small" />
        )}
      </AchievementCircle>
    </button>
  );
};

export default OverflowButton;
